module.exports = ".sidebar:after {\n  background: #fff; }\n\n.aside-inner {\n  box-shadow: 0px 0px 20px 4px rgba(218, 218, 218, 0.75); }\n"